import React, {useEffect, useState, memo} from 'react'
import { roundy } from './Utilities'
import Chart from 'react-apexcharts';
import { formatPeriodLabel, computeDisplayValue } from '../utils/indicatorFormatting'

function IndicatorWidget({editFlag, wid, data, openCallback, deleteCallback}) {

  // console.log('wid: ', wid)
  // console.log('data: ', data)

  return (
    <div style={{backgroundColor: data?.backgroundColor || '#ffffff'}} className='dwidget-container'>
        
        <div style={{position: 'relative'}} className='h-100'>
          {editFlag && (
            <div style={{position: 'absolute', right: '0'}}>
                <i onMouseDown={e => openCallback(wid)} style={{color: '#808080', cursor: 'pointer'}} className="fa-regular fa-pen-to-square"></i>
                <i onMouseDown={e => deleteCallback(wid)} style={{color: '#808080', cursor: 'pointer'}} className="fa-regular fa-circle-xmark px-2 pt-2"></i>
            </div>
          )}
          {Object.keys(data || {}).length == 0 ? (
            <div onMouseDown={editFlag ? () => openCallback?.(wid) : undefined} style={{color: '#8b8b8b', cursor: editFlag ? 'pointer' : 'default'}} className='text-center d-flex align-items-center justify-content-center flex-column h-100'>
              {editFlag ? <>Click edit button <br />to edit the indicator</> : 'No content available.'}
              {/* {editFlag && (
                <i onMouseDown={e => openCallback(wid)} style={{color: '#808080', cursor: 'pointer'}} className="fa-regular fa-pen-to-square"></i>
              )} */}
            </div>
          ) : (
            <div className='d-flex flex-column justify-content-center h-100'>
                <p className='dwidget-indicator-title'>{data.titleValue?.trim() || data.indicatorValue?.label}</p>
                {data.subtitleValue?.trim() && (
                  <p className='dwidget-indicator-subtitle'>{data.subtitleValue.trim()}</p>
                )}
                {(() => {
                  const { value, suffix } = computeDisplayValue(data.cardValue, data.displayModeValue, roundy)
                  const unitSuffix = data.unitSuffixValue?.trim()
                  return <p className='dwidget-indicator-value'>{value}{suffix}{unitSuffix ? ` ${unitSuffix}` : ''}</p>
                })()}
                <p className='dwidget-indicator-unit'>
                  {data.unitLabelValue?.trim() || data.unitValue?.label}
                  {data.showCountryInUnitLabel !== false && data.countryValue?.label ? ` (${data.countryValue.label})` : ''}
                </p>
                {data.transformationValue?.value && (
                  <p className='dwidget-indicator-unit'>{data.transformationValue.label}</p>
                )}
                <p className='dwidget-indicator-time'>
                  {data.timeframeValue && formatPeriodLabel(data.timeframeValue.value, data.frequencyValue?.value, data.periodFormatValue)}
                  {data.rangeValue && ' - '}
                  {data.timeframe2Value && formatPeriodLabel(data.timeframe2Value.value, data.frequencyValue?.value, data.periodFormatValue)}
              </p>
            </div>
          )}
        </div>
      
    </div>
  )
}

export default memo(IndicatorWidget)
